<template>
  <div class="cardContBorder" :class="this.variant" @click="select">
    <div class="price">{{price}} ₮</div>
    <div class="out" :class="this.variant">
      <i class="sr sr-check checkIcon mt-1 mr-1"/>
      <div class="license-card">
        <h4>{{ title }}</h4>
        <p>
          {{ textBody}}
        </p>
        <div class="row justify-content-center mt-lg-2">
          <p class="mt-auto mb-auto mr-2" v-if="licenseDate && this.variant !== 'info'">{{ $t('license.valid') }}: <span :class="'text-'+variant">{{ licenseDate }}</span></p>
          <ic-button  size="xs" v-if="this.variant === 'warning' || this.variant === 'danger'" @click="$emit('click')" style="padding: 5px; font-size: 14px; margin: 0" :class="variant" >
            <template>
              <i class="sr sr-timer"/> Сунгах
            </template>
          </ic-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    code: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: 'false'
    },
    textBody: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    price: {
      type: [String, Number],
      default: 2000
    },
    licenseDate: {
      type: String,
      required: false
    },
  },
  data() {
    return {
      selected: false
    }
  },
  computed: {
    variant() {
      if (this.status === 'paid')
        return 'success'
      if (this.status === 'expired')
        return 'danger'
      if (this.status === 'extend')
        return 'warning'
      if(this.status === 'empty' && this.selected)
        return 'selected'
      return 'info'
    }
  },
  methods: {
    select () {
      if(this.status === 'empty') {
        this.selected = !this.selected
        this.$emit('setFeeCode', this.code, this.selected)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.out{
  //background-color: var(--grey-or-blue-color);
  width: 100%;
}
.cardContBorder {
  background-color: #D9D9D9;
  border: 2px solid #D9D9D9;
  border-radius: 6px;
  display: flex;
  height: 100%;
}

.selected {
  background-color: #004F6C;
  border: 2px solid #004F6C;
}

.info:hover{
  box-shadow: 0 4px 10px var(--grey-or-blue-color) !important;
}

.success{
  background-color: #2EBD85;
  border: 2px solid #2EBD85;
}

.info {
  background-color: #D9D9D9;
  border: 2px solid #D9D9D9;
}
.success:hover {
  box-shadow: 0 4px 10px #2EBD85 !important;
}
.info:hover {
  box-shadow: 0 4px 10px #D9D9D9 !important;
}
.danger{
  background-color: var(--danger) !important;
  border: 2px solid var(--danger);
}
.danger:hover {
  box-shadow: 0 4px 10px var(--danger) !important;
}

.warning{
  background: #F0B400 !important;
  border: 2px solid #F0B400;
}
.text-warning{
  color: #F0B400;
}
.warning:hover {
  box-shadow: 0 4px 10px #F0B400 !important;
}

.price {
  writing-mode: vertical-lr;
  transform: rotate(180deg);
  text-align: center;
  color: white;
}
.checkIcon {
  float: right;
  color: white;
  font-size: 15px;
}
.license-card {
  border-radius: 5px;
  padding: 24px;
  text-align: center;
  background: linear-gradient(225deg, transparent 30px, var(--white-or-dark-color) 30px);
  height: 100%;
}

.license-card.success {
  border-color: var(--loader-color);
}


p {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  color: #939393;
}
h4{
  color: var(--blue-or-white-color);
}

button {
  margin-top: 16px;
  background: #0C293A !important;
}
</style>